export default __webpack_public_path__ + "static/media/alvin-balemesa-N8aho0A98Wk-unsplash.bcdea3cf.jpg";